import { faEye } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { TranscricaoListaItem } from '../../../../interfaces/entities/Transcricao/TranscricaoListaItem';
import TranscricaoSituacaoBadge from './TranscricaoSituacaoBadge';
import {
  formatTranscricaoDataHoraLinha,
  getTranscricaoDataSolicitacao,
  getTranscricaoItemId,
  getTranscricaoProtocolo,
  getTranscricaoStatusFromItem,
} from '../utils/transcricaoListaUtils';
import { sxTranscricaoListaCardDetalhesButton } from './sxProps';

interface Props {
  itens: TranscricaoListaItem[];
  onVerDetalhes: (item: TranscricaoListaItem) => void;
}

const TranscricaoListaCardList: React.FC<Props> = ({ itens, onVerDetalhes }) => {
  const accessibility = useAccessibility();

  return (
    <ul className="transcricao-lista-cards" aria-label="Minhas transcrições">
      {itens.map((item, index) => {
        const itemId = getTranscricaoItemId(item);
        const protocolo = getTranscricaoProtocolo(item);
        const status = getTranscricaoStatusFromItem(item);
        const dataSolicitacao = formatTranscricaoDataHoraLinha(getTranscricaoDataSolicitacao(item));

        return (
          <li
            key={String(itemId ?? `${protocolo}-${index}`)}
            className="transcricao-lista-card"
            style={{
              ...accessibility.contrastStyle,
              ...accessibility.contrastBorderAccessibility,
            }}
          >
            <div className="transcricao-lista-card-header">
              <div className="transcricao-lista-card-field">
                <span
                  className="transcricao-lista-card-label"
                  style={accessibility.textStyleAccessibility}
                >
                  Protocolo
                </span>
                <span
                  className="transcricao-lista-card-value"
                  style={accessibility.textStyleAccessibility}
                >
                  {protocolo}
                </span>
              </div>
              <TranscricaoSituacaoBadge status={status} />
            </div>

            <div className="transcricao-lista-card-field transcricao-lista-card-field--data">
              <span
                className="transcricao-lista-card-label"
                style={accessibility.textStyleAccessibility}
              >
                Data de solicitação
              </span>
              <span
                className="transcricao-lista-card-value"
                style={accessibility.textStyleAccessibility}
              >
                {dataSolicitacao}
              </span>
            </div>

            <hr className="transcricao-lista-card-divider" aria-hidden="true" />

            <Button
              type="button"
              variant="outlined"
              className="transcricao-lista-card-detalhes"
              sx={sxTranscricaoListaCardDetalhesButton}
              style={accessibility.buttonStyleAccessibility}
              onClick={() => onVerDetalhes(item)}
              aria-label={`Ver detalhes da transcrição ${protocolo}`}
              startIcon={
                <FontAwesomeIcon
                  icon={faEye as IconProp}
                  style={accessibility.buttonTextStyleAccessibility}
                  aria-hidden="true"
                />
              }
            >
              <b style={accessibility.buttonTextStyleAccessibility} aria-hidden="true">
                DETALHES
              </b>
            </Button>
          </li>
        );
      })}
    </ul>
  );
};

export default TranscricaoListaCardList;
